import React from 'react';
import classNames from 'classnames';
import './index.scss';

export const Row = ({ children, classes }) => <div className={classNames("flex", classes)}>{ children }</div>;
export const Column = ({ children, grow, width, classes }) => <div className={ classNames("column", grow ? `grow-${grow}` : null, classes) } style={{ width }}>{ children }</div>;